<template>
  <form @submit.prevent="submitForm">
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Motivo_rechazo_cod"
          label="Código"
          type="text"
          v-model="formData.Motivo_rechazo_cod"
          :required="true"
          :maxlength="50"
          :disabled="isEditing"
          helpText="Código único del motivo de rechazo"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="EsActivo"
          label="Estado"
          type="checkbox"
          v-model="formData.EsActivo"
          checkboxLabel="Motivo activo"
          helpText="Indica si el motivo está activo"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <FormField
          id="Nombre"
          label="Nombre"
          type="text"
          v-model="formData.Nombre"
          :required="true"
          :maxlength="200"
          helpText="Nombre del motivo de rechazo"
        />
      </div>
    </div>
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatMotivosRechazoForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    motivoRechazo: {
      type: Object,
      default: () => ({
        Motivo_rechazo_cod: '',
        EmpresaId: 1,
        Nombre: '',
        EsActivo: true
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.motivoRechazo }
    };
  },
  watch: {
    motivoRechazo: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
